import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['resubmitItem'];

  toggleRadio(e) {
    if (e.target.value === "resubmit") {
      this.resubmitItemTargets.forEach((el) => {
        el.classList.remove('d-none')
      });
    } else {
      this.resubmitItemTargets.forEach((el) => {
        el.classList.add('d-none')
      });
    }
  }
}
